import { routeConstants } from 'app/routes/route-constants';
import { Configuration } from 'app/components/metro-line/types';
import { RefObject } from 'react';
import { AdministrationEditTranslation } from 'app/area/administration/edit/constants';
import { RoleEditSectionType } from 'app/area/administration/edit/role/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { validationHighlights } from 'app/area/administration/shared/helpers';
import { PersonActionType } from 'app/area/administration/shared/types';

export const metroLineConfiguration = (
  id: number,
  actionType: PersonActionType,
  displayRestrictedAccess: boolean,
  detailsSectionRef: RefObject<HTMLDivElement | null>,
  accessToOperationSectionRef: RefObject<HTMLDivElement | null>,
  defaultValuesSectionRef: RefObject<HTMLDivElement | null>,
  accessToScreenSectionRef: RefObject<HTMLDivElement | null>,
  extendedAccessSectionRef: RefObject<HTMLDivElement | null>,
  restrictedAccessRef: RefObject<HTMLDivElement | null>,
  userOccurenceSectionRef: RefObject<HTMLDivElement | null>,
  validationErrors: { [key: string]: boolean }
): Configuration<RoleEditSectionType>[] => {
  const toAddingUserUrl = (configurationItem: Configuration<RoleEditSectionType>): Configuration<RoleEditSectionType> =>
    !isDefinedIncludingZero(id)
      ? {
        ...configurationItem,
        url: routeConstants.roleAddSectionFor(configurationItem.section)
      }
      : configurationItem;

  const filterInvisibles = (configurationItem: Configuration<RoleEditSectionType>): boolean => configurationItem.visible;

  return [
    {
      section: RoleEditSectionType.Details,
      visible: true,
      iconUrl: '/i/case-sections/default.svg',
      url: getScrollViewUrl(actionType, id, RoleEditSectionType.Details),
      label: (translation: AdministrationEditTranslation) => translation.edit_details_title,
      ref: detailsSectionRef,
      isValid: validationHighlights(['name', 'personId', 'additionalInformation'], validationErrors)
    },
    {
      section: RoleEditSectionType.AccessToOperation,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: getScrollViewUrl(actionType, id, RoleEditSectionType.AccessToOperation),
      label: (translation: AdministrationEditTranslation) => translation.operation,
      ref: accessToOperationSectionRef,
      isValid: validationHighlights(['accessOperations'], validationErrors)
    },
    {
      section: RoleEditSectionType.DefaultValues,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: getScrollViewUrl(actionType, id, RoleEditSectionType.DefaultValues),
      label: (translation: AdministrationEditTranslation) => translation.default_values,
      ref: defaultValuesSectionRef,
      isValid: validationHighlights(['defaultValues'], validationErrors)
    },
    {
      section: RoleEditSectionType.AccessToScreen,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: getScrollViewUrl(actionType, id, RoleEditSectionType.AccessToScreen),
      label: (translation: AdministrationEditTranslation) => translation.access_to_screen,
      ref: accessToScreenSectionRef,
      isValid: validationHighlights(['accessToScreen'], validationErrors)
    },
    {
      section: RoleEditSectionType.ExtendedAccess,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: getScrollViewUrl(actionType, id, RoleEditSectionType.ExtendedAccess),
      label: (translation: AdministrationEditTranslation) => translation.extended_access,
      ref: extendedAccessSectionRef,
      isValid: validationHighlights(['extendedAccess'], validationErrors)
    },
    {
      section: RoleEditSectionType.RestrictedAccess,
      visible: displayRestrictedAccess,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: getScrollViewUrl(actionType, id, RoleEditSectionType.RestrictedAccess),
      label: (translation: AdministrationEditTranslation) => translation.restricted_access,
      ref: restrictedAccessRef,
      isValid: validationHighlights(['restrictedAccess'], validationErrors)
    },
    {
      section: RoleEditSectionType.UserOccurence,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: getScrollViewUrl(actionType, id, RoleEditSectionType.UserOccurence),
      label: (translation: AdministrationEditTranslation) => translation.user_occurrence_in_preson_field_lists,
      ref: userOccurenceSectionRef,
      isValid: validationHighlights(['personExcluded'], validationErrors)
    }
  ].filter(filterInvisibles)
    .map(toAddingUserUrl);
};

const getScrollViewUrl = (actionType: PersonActionType, id: number, section: RoleEditSectionType) => {
  return actionType && {
    [PersonActionType.add]: routeConstants.roleAddSectionFor(section),
    [PersonActionType.edit]: routeConstants.roleEditSectionFor(id, section),
    [PersonActionType.duplicate]: routeConstants.roleDuplicateSectionFor(id, section)
  }[actionType];
};
